export default "__VITE_ASSET__Dz$tyO54__"